// extracted by mini-css-extract-plugin
module.exports = {"wrap-sign-in-panel":"wrap-sign-in-panel","sign-in-panel":"sign-in-panel","phone-input":"phone-input","icon":"icon"};